import React from 'react';
import { graphql } from 'gatsby';
import {
  BlogHeader,
  BlogPagination,
  BlogPostGrid,
  BlogTemplateWrapper,
} from 'partials';
import { PageHelmet } from 'components/pages';
import { liftNode, formatTitle } from 'utils';

export default class BlogTag extends React.Component {
  componentDidMount() {
    const { data, location } = this.props;
    const tag = data.ghostTag;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'Custom-PageView',
      pagePath: `${location.pathname}`,
      pageTitle: `${formatTitle(tag.name)}`,
    });
  }

  render() {
    const { data, pageContext } = this.props;
    const tag = data.ghostTag;
    const posts = data.allGhostPost.edges.map(liftNode);

    return (
      <BlogTemplateWrapper>
        <PageHelmet
          data={tag}
          title={tag.name}
          description={tag.description || `Rangle.io blog tag, ${tag.name}`}
          type="Series"
        />
        <div className="blog-context">
          <BlogHeader isTag tag={tag} />
          <BlogPostGrid posts={posts} />
          <BlogPagination pageContext={pageContext} />
        </div>
      </BlogTemplateWrapper>
    );
  }
}

export const pageQuery = graphql`
  query GhostTagQuery($slug: String!, $limit: Int!, $skip: Int!) {
    ghostTag(slug: { eq: $slug }) {
      ...GhostTagFields
    }
    allGhostPost(
      filter: { tags: { elemMatch: { slug: { eq: $slug } } } }
      sort: { order: DESC, fields: [published_at] }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          slug
          title
          feature_image
          tags {
            slug
          }
          published_at_pretty: published_at(formatString: "MMMM D, YYYY")
          authors {
            name
          }
        }
      }
    }
  }
`;
